/**
 * @generated SignedSource<<58ec6230ecb1700281b84830b67da069>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type salesChannelsQuery$variables = Record<PropertyKey, never>;
export type salesChannelsQuery$data = {
  readonly shopifyAuthEcommerceSettings: {
    readonly isTestStore: boolean;
  } | null;
  readonly subscription: {
    readonly areSalesChannelsEnabled: boolean;
  } | null;
  readonly " $fragmentSpreads": FragmentRefs<"salesChannelsActive">;
};
export type salesChannelsQuery = {
  response: salesChannelsQuery$data;
  variables: salesChannelsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "concreteType": "ShopifyAuthEcommerceSettings",
  "kind": "LinkedField",
  "name": "shopifyAuthEcommerceSettings",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isTestStore",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "areSalesChannelsEnabled",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "taskID",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "salesChannelsQuery",
    "selections": [
      (v0/*: any*/),
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "salesChannelsActive"
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "ZakekeSubscription",
        "kind": "LinkedField",
        "name": "subscription",
        "plural": false,
        "selections": [
          (v1/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "salesChannelsQuery",
    "selections": [
      (v0/*: any*/),
      {
        "alias": null,
        "args": null,
        "concreteType": "UserInfo",
        "kind": "LinkedField",
        "name": "user",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "userID",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "email",
            "storageKey": null
          },
          (v2/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": [
          {
            "kind": "Literal",
            "name": "status",
            "value": "ACTIVE"
          }
        ],
        "concreteType": "SalesChannel",
        "kind": "LinkedField",
        "name": "salesChannels",
        "plural": true,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "SalesChannelDetail",
            "kind": "LinkedField",
            "name": "detail",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "SalesChannelDetailProperties",
                "kind": "LinkedField",
                "name": "properties",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "name",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "EcommerceSettings",
            "kind": "LinkedField",
            "name": "ecommerceSettings",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "ecommerceGlobalID",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "ecommerceName",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "remoteUrl",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "isMarketplace",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "definitiveUrl",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": "salesChannels(status:\"ACTIVE\")"
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "ProductSwitcherTask",
        "kind": "LinkedField",
        "name": "productSwitcherTasks",
        "plural": true,
        "selections": [
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "state",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "taskType",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "lastError",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "elapsedTime",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "modifiedOn",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "ProductSwitcherTaskExtraData",
            "kind": "LinkedField",
            "name": "extraData",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "masterSalesChannelID",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "secondarySalesChannelID",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "delayMinutes",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v2/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "isSellerMigrating",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "ZakekeSubscription",
        "kind": "LinkedField",
        "name": "subscription",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          (v2/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "0b6029b8c008f56abe80552ad8475034",
    "id": null,
    "metadata": {},
    "name": "salesChannelsQuery",
    "operationKind": "query",
    "text": "query salesChannelsQuery {\n  shopifyAuthEcommerceSettings {\n    isTestStore\n  }\n  ...salesChannelsActive\n  subscription {\n    areSalesChannelsEnabled\n    id\n  }\n}\n\nfragment salesChannelsActive on Query {\n  user {\n    userID\n    email\n    id\n  }\n  salesChannels(status: ACTIVE) {\n    id\n    detail {\n      id\n      properties {\n        name\n      }\n    }\n    ecommerceSettings {\n      id\n      ecommerceGlobalID\n      ecommerceName\n      remoteUrl\n      isMarketplace\n      definitiveUrl\n    }\n  }\n  productSwitcherTasks {\n    taskID\n    state\n    taskType\n    lastError\n    elapsedTime\n    modifiedOn\n    extraData {\n      taskID\n      masterSalesChannelID\n      secondarySalesChannelID\n      delayMinutes\n    }\n    id\n  }\n  isSellerMigrating\n}\n"
  }
};
})();

(node as any).hash = "14ab9810766d46ce8fabe06bfcdded73";

export default node;
